<div class="manage-tags">
  <div class="close-model">
    <button type="button" class="btn-close " aria-label="Close" (click)="closeModel()"></button>
  </div>
  <div class="analyse-tag mx-3 mx-md-5 my-4 my-md-5">
    <br>
      <div class="row">
        <div class="col-8">
          <h3 class="ft-24-18">Manage tags</h3>
        </div>
        <div class="col-4 text-end">
          <button class="btn btn-primary ft-14 new-tag" (click)="newTag()">+ New tag</button>
        </div>
      </div>
      <br>
        <div class="d-none d-md-block"><br></div>
        <div class="row">
          <div class="form-group">
            <input type="text" [(ngModel)]="searchText"
              oninput="this.value = this.value.replace(/[^A-Za-z0-9\s-]/g, '')" class="form-control py-3"
              placeholder="Search tags">
            </div>
          </div>
          <br>
            <div class="scoll-inner pt-2" id="custom-scoll" (scroll)="onScroll($event)">
              @for (tags of allTagsList; track tags) {
                <div>
                  @if (tags.tag_name.toLowerCase().includes(searchText.toLowerCase())) {
                    <div class="row mx-1 mb-3 all-tags border-bottom">
                      <div class="col-6">
                        <p class="flex-tag ft-12 mb-2 alert all-tag-li" [ngClass]="'alert-' + tags.tag_color">{{
                        tags.tag_name }}</p>
                      </div>
                      <div class="col-6 ft-16 text-end">
                        <span class="cursor-pointer" (click)="editTag(tags)">
                          <i class="bi bi-pencil-square"></i>
                        </span>
                        <span class="mx-4 cursor-pointer" (click)="deleteTag(tags)">
                          <i class="bi bi-trash"></i>
                        </span>
                        <span class="cursor-pointer" (click)="tagsAnalyseDirect()" routerLink="portfolio/tags-analyse">
                          <i class="bi bi-graph-up-arrow"></i>
                        </span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>

          </div>
        </div>

        <ngx-loading [show]="loading">Loading...</ngx-loading>